import React from 'react';
import TableRowActionMenu from '../../BaseComponents/TableRowActionMenu';
import { Team } from '../../../api/teams';

type Props = {
  team: Team;
  onView: (team: Team) => void;
  onEdit: (team: Team) => void;
};

const TeamsTableRow = ({ team, onView, onEdit }: Props) => {
  const onOptionClick = (_id: string | number, action: string) => {
    if (action === 'view') {
      onView(team);
    }
    if (action === 'edit') {
      onEdit(team);
    }
  };

  return (
    <div className='table-row'>
      <div className='name'>{team.name}</div>
      <div className='desc'>{team.description}</div>
      <div className='actions'>
        <TableRowActionMenu
          options={[
            { key: 'view', value: 'View' },
            { key: 'edit', value: 'Edit' },
          ]}
          id={team.id}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};

export default TeamsTableRow;
